/**
 * フォームの情報
 */
const headTitleList: any[] = [
  {
    headTitle: "",
  },
  {
    headTitle: "代行者",
  },
  {
    headTitle: "対象施設",
  },
  {
    headTitle: "代行内容",
  },
  {
    headTitle: "進捗",
  },
  {
    headTitle: "依頼日",
  },
  {
    headTitle: "対応期日",
  },
  {
    headTitle: "完了日",
  },
];
export { headTitleList };
